
export const COMPOSITIONS_VIEW_TABLE = 'COMPOSITIONS_VIEW_TABLE'
export function setViewAsTable() {
  return {
    type: COMPOSITIONS_VIEW_TABLE
  }
}

export const COMPOSITIONS_VIEW_GRID = 'COMPOSITIONS_VIEW_GRID'
export function setViewAsGrid() {
  return {
    type: COMPOSITIONS_VIEW_GRID
  }
}
